var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.initialCalcHeight > 0
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "show-more__txt-wrapper",
            class: { "show-more__txt-wrapper--closed": !_vm.open },
            style: {
              "max-height": _vm.isPreview
                ? "unset"
                : (_vm.open ? _vm.initialCalcHeight : _vm.closedHeight) + "px"
            }
          },
          [_vm._t("default")],
          2
        ),
        _vm._v(" "),
        _vm.initialCalcHeight > _vm.closedHeight
          ? _c(
              "div",
              {
                staticClass: "show-more__btn-wrapper",
                style: {
                  "justify-content":
                    _vm.positionCenter === "1" ? "center" : "unset"
                }
              },
              [
                !_vm.open
                  ? _c(
                      "div",
                      {
                        staticClass: "show-more__btn",
                        on: {
                          click: function($event) {
                            _vm.open = !_vm.open
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.btnTxt1))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.open
                  ? _c(
                      "div",
                      {
                        staticClass: "show-more__btn",
                        on: {
                          click: function($event) {
                            _vm.open = !_vm.open
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.btnTxt2))]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }